import React from 'react'
import Collapse from '@mui/material/Collapse'

import Markdown from '@components/markdown'
import PlusMinusIcon from '@components/icons/plusminus'
import styles from '@components/programmatic_blocks/faq_category.module.scss'
import faqStyles from '@components/programmatic_blocks/faqs.module.scss'

const Faq = ({ faq }) => {
  if (!faq || !faq.fields) return null
  return (
    <div className="faq">
      <div className={faqStyles.faq__question}>{faq.fields.question}</div>
      <div className={faqStyles.faq__answer}>
        <Markdown>{faq.fields.answer}</Markdown>
      </div>
    </div>
  )
}

class FaqCategory extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      in: false,
    }
  }

  toggle = () => {
    this.setState({
      in: !this.state.in,
    })
  }

  render() {
    const faqs = this.props.faqs.map((faq, i) => <Faq key={i} faq={faq} />)

    return (
      <div className={styles.faqCategory}>
        <div className={styles.faqCategory__header} onClick={this.toggle}>
          <div className={styles.faqCategory__name}>{this.props.name}</div>
          <PlusMinusIcon className={styles.faqCategory__icon} minus={this.state.in} />
        </div>
        <Collapse in={this.state.in}>{faqs}</Collapse>
      </div>
    )
  }
}

export default FaqCategory
